import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './LoginForm.scss';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [mussPasswortAendern, setMussPasswortAendern] = useState(false);
  const [token, setToken] = useState('');

  // ===== LOGIN =====
  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');

    try {
      const response = await axios.post(
        'https://jugehoerig-backend.onrender.com/api/login',
        { benutzername: username, passwort: password }
      );

      const { token, id, userTypes, rolle, passwort_geaendert } = response.data;

      if (passwort_geaendert === 0) {
        setMussPasswortAendern(true);
        setToken(token);
      } else {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify({ userTypes, rolle, id }));
        window.location.href = '/';
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
        'Fehler beim Login. Bitte überprüfen Sie Benutzername und Passwort.'
      );
    }
  };

  // ===== PASSWORT ÄNDERN (ERSTLOGIN) =====
  const handleChangePassword = async (event) => {
    event.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    try {
      await axios.put(
        'https://jugehoerig-backend.onrender.com/api/login/change-password-erstlogin',
        { neuesPasswort: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert('Passwort erfolgreich geändert. Bitte neu einloggen.');
      window.location.href = '/login';
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Ändern des Passworts.');
    }
  };

  return (
    <div className="login-container">
      {!mussPasswortAendern ? (
        <>
          <form className="login-form" onSubmit={handleLogin}>
            <h2 className="login-title">Login</h2>

            <div className="form-group">
              <label>Benutzername</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-button">
              Login
            </button>
          </form>

          {/* ===== PASSWORT VERGESSEN LINK ===== */}
          <div className="forgot-password">
            <Link to="/password-reset" className="forgot-password-link">
              Passwort vergessen?
            </Link>
          </div>
        </>
      ) : (
        <form className="login-form" onSubmit={handleChangePassword}>
          <h2 className="login-title">Passwort ändern</h2>

          <div className="form-group">
            <label>Neues Passwort</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Passwort wiederholen</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="submit-button">
            Passwort ändern
          </button>
        </form>
      )}
    </div>
  );
};

export default LoginForm;
